export { showCategoryList };

const showCategoryList = () => {
  (function ($) {
    let menuCategory = $(".blog-category-list");
    let childTree = $(".blog-category-list ul");
    menuCategory.on("click", function (e) {
      // e.stopPropagation();
      $(this).toggleClass("active");
      childTree.slideToggle("fast");
      childTree.on("click", function (e) {
        // e.stopPropagation();
      });
    });
  })(jQuery);
};
